import { recordContentViewFn } from "@/actions/community/handler";
import { useEffect } from "react";

export function ContentViewTracker({
  resourceType,
  resourceId,
}: {
  resourceType: "forum_question" | "library_entry";
  resourceId: string;
}) {
  useEffect(() => {
    const storageKey = "thecoach:visitor-key";
    let visitorKey = localStorage.getItem(storageKey);
    if (!visitorKey) {
      visitorKey = `${crypto.randomUUID()}-${Date.now()}`;
      localStorage.setItem(storageKey, visitorKey);
    }
    void recordContentViewFn({
      data: { resourceType, resourceId, visitorKey },
    });
  }, [resourceId, resourceType]);
  return null;
}
